import { useMutation, useQuery } from "@tanstack/react-query";
import { LunchPackagesPayloadInterface } from "../../Constants/Interfaces/payloadInterface/LunchPackagesPayload.interface";
import { get, post } from "../../api/client";
import queryClient from "../../config/queryClient";

export const LUNCH_PACKAGES_KEY = {
  LUNCH_PACKAGES_LIST: "LUNCH_PACKAGES_LIST",
};

export const useAddLunchPackages = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: Error) => unknown;
}) =>
  useMutation(
    (data: LunchPackagesPayloadInterface) => {
      return post({
        url: "api/v1/lunch-packages/create",
        body: data,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [LUNCH_PACKAGES_KEY.LUNCH_PACKAGES_LIST],
        });
      },
      onError,
    }
  );

export const useGetAllLunchPackages = () =>
  useQuery([LUNCH_PACKAGES_KEY.LUNCH_PACKAGES_LIST], () =>
    get({
      url: "api/v1/lunch-packages",
    })
  );

export const useGetLunchPackagesOptions = () => {
  return useQuery([LUNCH_PACKAGES_KEY.LUNCH_PACKAGES_LIST], () =>
    get({
      url: "api/v1/lunch-packages/options",
    })
  );
};
